import { cn } from "@/lib/utils";

export const cx = cn;
